import React, { useState } from "react";
import { Field } from "../components/FormControls";
import { fieldError } from "../../utils/validationUtils";
import { cancelOrderJson } from "../../api/api";
import "./CancelOrderForm.css";
import SuccessPopup from "../components/SuccessPopup";
import arrowLeft from "../../assets/arrow-left.png";
import superpharmLogo from "../../assets/superpharm-logo.svg";

const initial = {
    orderNumber: "",
    fullname: "",
    email: "",
    phone: "",
    reason: "",
};

export default function CancelOrderForm() {
    const [form, setForm] = useState(initial);
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [submitMessage, setSubmitMessage] = useState<string | null>(null);

    const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const t = e.target as HTMLInputElement;
        const { name, value } = t;
        setForm(f => ({ ...f, [name]: value }));
        setErrors((er: any) => ({ ...er, [name]: fieldError(name, value) }));
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setSubmitMessage(null);

        const focusErrors = {
            orderNumber: fieldError("orderNumber", form.orderNumber),
            fullname: fieldError("fullname", form.fullname),
            email: fieldError("email", form.email),
            phone: fieldError("phone", form.phone),
            // reason: fieldError("reason", form.reason),
        };
        setErrors(focusErrors);

        if (Object.values(focusErrors).some(Boolean)) {
            setLoading(false);
            return;
        }

        try {
            const payload = {
                orderNumber: form.orderNumber,
                fullname: form.fullname,
                email: form.email,
                phone: form.phone,
                reason: form.reason,
            };
            const response = await cancelOrderJson(payload);
            if (response && response.success) {
                setShowSuccess(true);
                setForm(initial);
                setErrors({});
            } else if (response && response.success === false && response.message) {
                setSubmitMessage(response.message);
            }
        } catch (err: any) {
            alert(err?.message || "שליחת הטופס נכשלה. נסה שוב מאוחר יותר.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main dir="rtl" className="cancel-order-page-root">
            <SuccessPopup open={showSuccess} onClose={() => setShowSuccess(false)} />
            <div className="cancel-order-page">
                <div className="cancel-order-card">
                    <div className="cancel-order-header">
                        <div className="cancel-order-header-row">
                            <button
                                type="button"
                                className="cancel-order-back-btn"
                                aria-label="חזרה"
                                onClick={() => {
                                    window.location.href = process.env.REACT_APP_LOBBY_LINK || 'https://glassix.consist.co.il/Superpharm-iframes/lobby';
                                }}
                            >
                                <img src={arrowLeft} alt="" className="cancel-order-back-icon" />
                            </button>
                            <img src={superpharmLogo} alt="Super-Pharm" className="cancel-order-logo" />
                        </div>
                        <div className="cancel-order-title-wrap">
                            <h1 className="cancel-order-title">ביטול הזמנה</h1>
                        </div>
                        <div className="cancel-order-intro">
                            <p>
                                אם ההזמנה עדיין בסטטוס <strong>"התקבלה"</strong> ניתן לבטל אותה בעמוד "ההזמנות שלך" על ידי לחיצה על "ביטול הזמנה". ההזמנה תבוטל ולא יתבצע חיוב. לביטול הזמנות בסטטוס "אחר" אנא מלאו את הטופס מטה ואנו נדאג לטפל בבקשתכם בהקדם. שימו לב – מסירת פרטים מדויקים תסייע בקיצור התהליך.
                            </p>
                            <p>
                                <strong>
                                    טופס זה אינו מיועד לביטול הזמנות של מוצרים שנרכשו ממוכר חיצוני. לביטול הזמנה ממוכר חיצוני יש לפנות למדיניות משלוחים והחזרות של המוכר החיצוני בעמוד המוצר.
                                </strong>
                            </p>
                        </div>
                    </div>
                    <form className="cancel-order-form" onSubmit={handleSubmit} onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target instanceof HTMLElement && e.target.tagName !== 'BUTTON' && e.target.tagName !== 'TEXTAREA') {
                            e.preventDefault();
                        }
                    }}>
                        <div className="cancel-order-grid">
                            <div className="cancel-order-input cancel-order-input-orderNumber">
                                <Field id="orderNumber" name="orderNumber" label="מספר הזמנה" inputMode="numeric" value={form.orderNumber} onChange={onChange} error={errors.orderNumber} classPrefix="cancel-order-" />
                            </div>
                            {/* <div className="cancel-order-input cancel-order-input-reason">
                                <Field
                                    id="reason"
                                    name="reason"
                                    label="סיבת הביטול"
                                    textarea
                                    maxLength={3000}
                                    value={form.reason}
                                    onChange={onChange}
                                    error={errors.reason}
                                    classPrefix="cancel-order-"
                                />
                            </div> */}
                            <div className="cancel-order-input cancel-order-input-fullname">
                                <Field id="fullname" name="fullname" label="שם מלא" value={form.fullname} onChange={onChange} error={errors.fullname} classPrefix="cancel-order-" />
                            </div>
                            <div className="cancel-order-input cancel-order-input-phone">
                                <Field id="phone" name="phone" inputMode="tel" label="טלפון" minLength={10} maxLength={12} value={form.phone} onChange={onChange} error={errors.phone} classPrefix="cancel-order-" />
                            </div>
                            <div className="cancel-order-input cancel-order-input-email">
                                <Field id="email" name="email" type="email" label="כתובת מייל" value={form.email} onChange={onChange} error={errors.email} classPrefix="cancel-order-" />
                            </div>
                        </div>

                        <div className="submit">
                            <button type="submit" className="cancel-order-submit-btn" disabled={loading}>{loading ? "שולח..." : "שליחה"}<img src={arrowLeft} alt="" /></button>
                        </div>

                        {submitMessage && (
                            <div className="cancel-order-submit-notice">
                                {submitMessage}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </main>
    );
}
